import React, { useState } from 'react';
import { WarehouseQuoteStorageDataForm, WarehouseQuoteStorageShowDataForm } from '../../../../../../../app/models/WareHouseQuoteStorage';
import useWarehouseStorageService from '../../../../../../../app/services/hooks/useWareHouseQuoteStorageService';
import { ServiceResponse } from '../../../../../../../app/services/shared/interfaces';

interface Props {
    storageform: WarehouseQuoteStorageShowDataForm;

}

const WarehouseQuoteStorageShowForm = ({ 
    storageform,
 }: Props) => {

  return (
    <>
      <div className="mb-2 row">
        <label className="col-md-3 col-form-label">Almacén</label>
        <div className="col-md-9">
          <input
            type="text"
            className="form-control"
            name="depot"
            value={storageform.depot}
            disabled
          />
        </div>
      </div>

      <div className="mb-2 row">
        <label className="col-md-3 col-form-label">Días libres</label>
        <div className="col-md-9">
          <input
            type="number"
            className="form-control"
            name="free_days"
            value={storageform.free_days ?? ''}
            disabled
          />
        </div>
      </div> 
    </>
  );
 }
export default WarehouseQuoteStorageShowForm;
